<template>
  <div class>
    <!-- <div class="card-body"> -->
    <div class="row mb-15">
      <div class="col-md-9 br">
        <filters @filter="filtD" :sectorData="sectorList" :filterOptions="filterOpt" :pType="title"></filters>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <!-- {{title}} {{title==='return-analysis'}} -->
          <input
            class="form-control"
            v-model="searchText"
            placeholder="Search"
            @keyup="searchList($event)"
          >
        </div>
        <div class="form-group">
          <select class="form-control" v-model="selRangeFilter" @change="rangeF($event)">
            <option
              v-for="(d, index) in mcFilter"
              v-bind:key="d.id+index"
              :value="index"
            >{{d.value}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mb-15">
      <div class="col-md-12">
        <div class="table-responsive app" v-dragscroll="true">
          <table
            :id="title"
            class="table table-bordered fonts11 app-inner"
            
          >
            <thead v-if="title==='return-analysis'">
              <tr v-if="rawdata && rawdata.length>0">
                <th>Sr.</th>
                <th
                  @click="sortPDataColumn(field, index, 'data')"
                  style="font-size:.92em"
                  class="data-cell column-sort"
                  v-for="(field, index, key) in tablefields"
                  v-bind:key="'field'+field+index+key"
                >
                  {{field.name}}
                  <span v-if="field.isSortable">
                    <i
                      class="fa fa-caret-down"
                      v-if="(field.sort_order == 1 || field.sort_order == 0)"
                    ></i>
                    <i
                      class="fa fa-caret-up"
                      v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                    ></i>
                  </span>
                </th>
              </tr>
            </thead>
            <thead v-else>
              <tr v-if="rawdata && rawdata.length>0">
                <th>Sr.</th>
                <th
                  @click="sortPColumn(field, index)"
                  style="font-size:.92em"
                  class="data-cell column-sort"
                  v-for="(field, index, key) in tablefields"
                  v-bind:key="'field'+field+index+key"
                >
                  {{field.name}}
                  <span v-if="field.isSortable">
                    <i
                      class="fa fa-caret-down"
                      v-if="(field.sort_order == 1 || field.sort_order == 0)"
                    ></i>
                    <i
                      class="fa fa-caret-up"
                      v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                    ></i>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody v-if="title==='return-analysis'">
              <tr v-for="(row, index, key) in rawdata" v-bind:key="'row'+row+index">
                <td>{{index+1}}</td>
                <td v-for="(field, ind) in tablefields" v-bind:key="ind+'-td-'+index+key">
                  <span
                    v-if="field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization' || field.title === title"
                  >
                    <span v-if="field.isLink">
                      <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                    </span>
                    <span
                      v-else
                    >{{(field.isNumeric)? getChecknFixed(row[field.title]): row[field.title]}}</span>
                  </span>
                  <span v-else>
                    <span
                      v-if="row['data']"
                    >{{(field.isNumeric)? getChecknFixed(row['data'][field.title]): row['data'][field.title]}}</span>
                  </span>
                </td>
              </tr>
            </tbody>
            <!-- <tbody v-else-if="title==='s1'">
              <tr v-for="(row, index, key) in rawdata" v-bind:key="'row'+row+index">
                <td>{{index+1}}</td>
                <td v-for="(field, ind) in tablefields" v-bind:key="ind+'-td-'+index+key">
                  <span
                    v-if="field.title === 'sector_name' || field.title === 'co_code' || field.title === 'name' || field.title === 'market_capitalization' || field.title === title"
                  >
                    <span v-if="field.isLink">
                      <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                    </span>
                    <span
                      v-else
                    >{{(field.isNumeric)? getChecknFixed(row[field.title]): row[field.title]}}</span>
                  </span>
                  <span v-else>
                    <span v-if="row['s1_data']" :class="(field.hasColor && row['color'][field.color])? 'f'+row['color'][field.color]: ''">{{(field.isNumeric)? getChecknFixed(row['s1_data'][field.title]): getLabel(row['s1_data'][field.title])}}</span>
                  </span>
                </td>
              </tr>
            </tbody>-->
            <tbody v-else-if="title!=='s1' && title!=='return-analysis'">
              <tr v-for="(row, index) in rawdata" v-bind:key="'row'+row+index">
                <td>{{index+1}}</td>
                <td v-for="(field, ind) in tablefields" v-bind:key="ind+'-td-'+index">
                  <span v-if="field.isLink">
                    <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                  </span>
                  <span v-else>{{(field.isNumeric)? getFixed(row[field.title]): row[field.title]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="alert alert-danger" role="alert"  v-if="rawdata && rawdata.length===0">No data found!</div>
        </div>
        <!-- <div class="row" v-else>
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">No data found!</div>
        </div>
        </div>-->
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  mixins: [commonMixins],
  props: [
    "title",
    "pData",
    "pTableFields",
    "pfilterOptions",
    "mcFilter",
    "sectorList"
  ],
  created() {},
  data() {
    return {
      rawdata: [],
      rawSearchData: [],
      curYear: new Date().getFullYear(),
      tablefields: [],
      filterOpt: [],
      selRangeFilter: 0,
      searchText: ""
      // ddate: new Date().setDate(new Date().getDate() - 1),
      // minRange: [],
      // maxRange: [],
      // selFilter: [],
      // sectorname:  ""
    };
  },
  methods: {
    filtD(obj) {
      this.$emit("filterD", obj);
    },
    rangeF(e) {
      this.$emit("rangeFilt", e);
    },
    searchList(e) {
      this.$emit("searchD", e);
    },
    searchList(e) {
      this.selRangeFilter = 0;
      this.selFilter = "";
      if (this.searchText === null || this.searchText === "") {
        this.rawdata = this.rawSearchData;
        return this.rawdata;
      } else if (this.searchText.length <= 2) {
        this.rawdata = this.rawSearchData;
        return this.rawdata;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawdata = this.rawSearchData.filter(rd => {
          return (
            rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.name
              ? rd.name.toLowerCase().includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    }
  },
  watch: {
    pData: function(value) {
      this.rawdata = value;
      this.rawSearchData = value;
    },
    pfilterOptions: function(value) {
      this.filterOpt = value;
    },
    pTableFields: function(value) {
      this.tablefields = value;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/p-analysis-data.vue